import { axios } from '@/utils/request'

const api = {
  goodsOptions: '/badminapi/jielong/goodsOptions',
  youhuiquanOptions: '/badminapi/jielong/youhuiquanOptions',
  jielongDetail: '/badminapi/jielong/jielongDetail',
  jielongList: '/badminapi/jielong/jielongList',
  jielongEdit: '/badminapi/jielong/jielongEdit',
  jielongAdd: '/badminapi/jielong/jielongAdd',
  jielongDelete: '/badminapi/jielong/jielongDelete',
  setJielongAllStatus: '/badminapi/jielong/setJielongAllStatus',
  jielongOrderList: '/badminapi/jielong/orderList',
}

export default api

export function getJielongList(parameter) {
  return axios({
    url: api.jielongList,
    method: 'get',
    params: parameter
  })
}
export function getJielongDetail(parameter) {
  return axios({
    url: api.jielongDetail,
    method: 'get',
    params: parameter
  })
}
export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}
export function getYouhuiquanOptions(parameter) {
  return axios({
    url: api.youhuiquanOptions,
    method: 'get',
    params: parameter
  })
}
export function editJielong(parameter) {
  return axios({
    url: api.jielongEdit,
    method: 'post',
    data: parameter
  })
}
export function addJielong(parameter) {
  console.log('addJielong');
  console.log(parameter);
  return axios({
    url: api.jielongAdd,
    method: 'post',
    data: parameter
  })
}

export function deleteJielong(parameter) {
  return axios({
    url: api.jielongDelete,
    method: 'post',
    data: parameter
  })
}


export function setJielongAllStatus(parameter) {
  return axios({
    url: api.setJielongAllStatus,
    method: 'post',
    data: parameter
  })
}
export function getJielongUserList(parameter) {
  return axios({
    url: api.jielongOrderList,
    method: 'post',
    data: parameter
  })
}